import React, { Component } from "react";
import PropTypes from "prop-types";
import Box from "@material-ui/core/Box";
import Button from "@material-ui/core/Button";
import FormHelperText from "@material-ui/core/FormHelperText";
import { ArrowBackIosOutlined, SendOutlined } from "@material-ui/icons";
import { ButtonGroup, List, Typography } from "@material-ui/core";
import ReasonCancelRDV from "./ReasonCancelRDV";
import { connect } from "react-redux";

class AnnulationRdv extends Component {
  constructor(props) {
    super(props);
    this.state = {
      step: 1, // étape actuelle
      motif: "", // motif d'annulation choisi par l'utilisateur
      description: "", // motif d'annulation choisi par l'utilisateur
      errors: {} // erreurs de validation pour chaque étape
    };
  }

  // fonction pour passer à l'étape suivante
  nextStep = () => {
    const { step } = this.state;
    const errors = this.validateStep(step);
    if (Object.keys(errors).length === 0) {
      this.setState({
        step: step + 1,
        errors: {}
      });
    } else {
      this.setState({ errors });
    }
  };

  // fonction pour revenir à l'étape précédente
  prevStep = () => {
    const { step } = this.state;
    this.setState({
      step: step - 1,
      errors: {}
    });
  };

  // fonction pour gérer la sélection du motif d'annulation
  handleMotifChange = event => {
    this.setState({
      motif: event.target.value
    });
  };

  handleChangeDescription = event => {
    const { value } = event.target;
    this.setState({
      description: value
    });
  };

  // fonction pour soumettre le formulaire d'annulation
  handleSubmit = event => {
    event.preventDefault();
    const errors = this.validateStep(3);

    if (Object.keys(errors).length === 0) {
      this.props.onSaveReason(
        this.props.dataSource["rdvSmsData"].data[(this.props?.selectedRdv)]
          .identifiant_rdv,
        this.props.dataSource["currentCode"],
        this.state.motif,
        this.state.description
      );
      this.props.onCancel(
        this.props.dataSource["rdvSmsData"].data[(this.props?.selectedRdv)]
          .identifiant_rdv,
        this.props.dataSource["rdvSmsData"].data[(this.props?.selectedRdv)]
          .cookie
      );
      this.props.handleShowRdvButton();
      this.nextStep();
    } else {
      this.setState({ errors });
    }
  };

  // fonction pour valider les données pour une étape donnée
  validateStep = step => {
    const { motif } = this.state;
    const { validations, dataSource } = this.props;
    let listReasons = dataSource["canceledReasons"];
    const errors = {};
    switch (step) {
      case 1:
        if (!validations.confirmation) {
          errors.confirmation = "Confirmation requise";
        }
        break;
      case 3:
        if (!motif) {
          errors.motif = "Motif requis";
          errors.description = false;
        } else if (
          motif === listReasons.slice(-1)[0] + 1 &&
          !this.state.description
        ) {
          errors.motif = "Veuillez ajouter une raison";
          errors.description = true;
        }
        break;
      case 2:
        if (!validations.confirmation) {
          errors.confirmation = "Confirmation requise";
        }
        break;
      default:
        break;
    }
    return errors;
  };

  render() {
    const { step, errors } = this.state;
    const { dataSource } = this.props;
    switch (step) {
      case 1:
        return (
          <>
            <Box
              sx={{
                display: "block",
                p: "30px auto 30px auto",
                fontSize: "0.875rem",
                fontWeight: "400",
                color: "#212121",
                alignItems: "center",
                width: "100%"
              }}
            >
              <List
                sx={{
                  width: "100%",
                  bgcolor: "background.paper",
                  textAlign: "center"
                }}
              >
                <Typography
                  style={{
                    alignItems: "center",
                    color: "#212121",
                    fontSize: "14px",
                    margin: 30,
                    marginLeft: 8,
                    textAlign: "center"
                  }}
                >
                  Êtes-vous sûr de vouloir annuler ce rendez-vous ?
                </Typography>
                {errors.confirmation && (
                  <FormHelperText error>{errors.confirmation}</FormHelperText>
                )}
              </List>
            </Box>

            <ButtonGroup
              disableElevation
              variant="contained"
              aria-label="Disabled elevation buttons"
              style={{
                width: "100%",
                borderRadius: "0 0 8px 8px",
                borderTop: "1px solid #C8C8C8"
              }}
            >
              <Button
                style={{
                  width: "100%",
                  color: "red",
                  backgroundColor: "white",
                  borderRadius: "0 0 0 8px",
                  textTransform: "none"
                }}
                onClick={() => {
                  this.nextStep();
                }}
              >
                Annuler RDV
              </Button>
              <Button
                startIcon={<ArrowBackIosOutlined />}
                style={{
                  width: "100%",
                  color: "#009EFF",
                  backgroundColor: "white",
                  borderRadius: "0 0 8px 0",
                  textTransform: "none"
                }}
                onClick={() => {
                  this.prevStep();
                  this.props.onPrevStep(false);
                }}
              >
                Retour
              </Button>
            </ButtonGroup>
          </>
        );
      case 2:
        return (
          <>
            <Box
              sx={{
                fontSize: "0.875rem",
                fontWeight: "400",
                color: "#212121",
                margin: 0
              }}
            >
              <ReasonCancelRDV
                errors={errors}
                handleOnChange={this.handleMotifChange}
                handleChangeDescription={this.handleChangeDescription}
              />
              <div style={{ padding: 10 }}>
                <Button
                  startIcon={
                    <SendOutlined style={{ transform: "rotate(-45deg)" }} />
                  }
                  onClick={this.handleSubmit}
                  type="submit"
                  fullWidth
                  variant="outlined"
                  style={{
                    backgroundColor: "#009EFF",
                    border: "#009EFF",
                    color: "white",
                    borderRadius: "50px",
                    height: "40px",
                    textTransform: "none",
                    fontSize: "16px",
                    width: "100%"
                  }}
                >
                  {`Envoyer`}
                </Button>
              </div>
            </Box>
          </>
        );
      case 3:
        return (
          <>
            <Box
              sx={{
                display: "block",
                p: "0 0 30px 0",
                fontSize: "0.875rem",
                fontWeight: "400",
                color: "#212121",
                textAlign: "center"
              }}
            >
              <Box
                style={{
                  fontSize: "14px",
                  fontWeight: "400",
                  width: "100%",
                  textAlign: "center"
                }}
              >
                <div
                  style={{
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center"
                  }}
                >
                  {dataSource["cancelAppointmentSMS"]?.success ? (
                    <>
                      <img
                        src="icons/check.svg"
                        alt="icon"
                        width={22}
                        style={{ marginRight: "4px" }}
                      />
                      <Typography
                        style={{
                          display: "block",
                          alignItems: "center",
                          fontSize: "16px",
                          margin: 20,
                          marginLeft: 16,
                          color: "#212121"
                        }}
                      >
                        {dataSource["cancelAppointmentSMS"]?.message_html}
                      </Typography>
                    </>
                  ) : (
                    <Typography
                      style={{
                        display: "block",
                        alignItems: "center",
                        fontSize: "16px",
                        margin: 20,
                        marginLeft: 16,
                        color: "#212121"
                      }}
                    >
                      {dataSource["cancelAppointmentSMS"]?.message_html}
                    </Typography>
                  )}
                </div>
              </Box>
              {!dataSource["saveReasonCancelRdvSMS"]?.bresult ? (
                <div
                  style={{
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center"
                  }}
                >
                  <Typography
                    style={{
                      display: "block",
                      alignItems: "center",
                      fontSize: "16px",
                      margin: 10,
                      marginLeft: 16,
                      color: "#CF0000"
                    }}
                  >
                    {dataSource["saveReasonCancelRdvSMS"]?.message}
                  </Typography>
                </div>
              ) : (
                <div
                  style={{
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center"
                  }}
                >
                  <Typography
                    style={{
                      display: "block",
                      alignItems: "center",
                      fontSize: "16px",
                      margin: 10,
                      marginLeft: 16,
                      color: "#212121"
                    }}
                  >
                    Merci de nous tenir informé, nous restons à votre
                    disposition.
                  </Typography>
                </div>
              )}
            </Box>
          </>
        );
      default:
        return null;
    }
  }
}

AnnulationRdv.propTypes = {
  handleShowRdvButton: PropTypes.func,
  selectedRdv: PropTypes.any,
  dataSource: PropTypes.any,
  validations: PropTypes.shape({
    confirmation: PropTypes.bool.isRequired
  }).isRequired,
  onCancel: PropTypes.func.isRequired,
  onSaveReason: PropTypes.func.isRequired,
  onPrevStep: PropTypes.func
};

const mapStateToProps = state => {
  return {
    dataSource: state.dataSource
  };
};

const mapDispatchToProps = () => {
  return {};
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(AnnulationRdv);
